
import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SEOService {
  constructor(@Inject(DOCUMENT) private dom) {}

  updateCanonicalUrl(
    url: string,
    alternateUrls?: {
      it: string;
      en: string;
    }
  ) {
    const head = this.dom.getElementsByTagName('head')[0];
    let element: HTMLLinkElement =
      this.dom.querySelector(`link[rel='canonical']`) || null;
    if (element == null) {
      element = this.dom.createElement('link') as HTMLLinkElement;
      head.appendChild(element);
    }
    element.setAttribute('rel', 'canonical');
    element.setAttribute('href', url);

    this.setHreflangAlternates(url, alternateUrls);
  }

  private setHreflangAlternates(
    url: string,
    alternateUrls?: {
      it: string;
      en: string;
    }
  ) {
    const head = this.dom.getElementsByTagName('head')[0];
    const u = new URL(url);
    const baseUrl = environment.canonicalUrl.endsWith('/')
      ? environment.canonicalUrl
      : `${environment.canonicalUrl}/`;

    const pathWithoutLang = u.pathname.replace(/^\/(it|en)(?=\/|$)/, '') || '/';
    const normalizedPath = pathWithoutLang === '/' ? '/home' : pathWithoutLang;

    const languages = ['it', 'en', 'x-default'] as const;

    for (const lang of languages) {
      const targetLang: 'it' | 'en' = lang === 'it' ? 'it' : 'en';
      const fallbackPath = `${baseUrl}${targetLang}${normalizedPath}`;
      const alternateUrlFromInput =
        targetLang === 'it' ? alternateUrls?.it : alternateUrls?.en;
      const alternateUrl = alternateUrlFromInput
        ? this.normalizeAlternateUrl(alternateUrlFromInput, targetLang, baseUrl)
        : fallbackPath;

      let element: HTMLLinkElement =
        this.dom.querySelector(`link[hreflang='${lang}']`) || null;
      if (element == null) {
        element = this.dom.createElement('link') as HTMLLinkElement;
        head.appendChild(element);
      }
      element.setAttribute('rel', 'alternate');
      element.setAttribute('href', alternateUrl);
      element.setAttribute('hreflang', lang);
    }
  }

  private normalizeAlternateUrl(
    url: string,
    lang: 'it' | 'en',
    baseUrl: string
  ): string {
    const absoluteUrl = url.startsWith('http')
      ? url
      : `${baseUrl}${url.replace(/^\//, '')}`;
    const parsed = new URL(absoluteUrl);
    const strippedPath =
      parsed.pathname.replace(/^\/(it|en)(?=\/|$)/, '') || '/';
    const normalizedPath = strippedPath === '/' ? '/home' : strippedPath;
    return `${baseUrl}${lang}${normalizedPath}`;
  }
}
